import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import config from '../../../config'
import Header from '../../Header';
import Footer from '../../Pages/Footer';
import Nofees from '../../Pages/Presale/IconBox/Nofees'
import Multiswap from '../../Pages/Presale/IconBox/Multiswap'
import AccordionBox from '../../Pages/Presale/Accordion'
import Oneclickswap from '../../Pages/Presale/IconBox/Oneclickswap'
import '../../Dashboard/css/liquiditypool.css';
import { Container, Row, Col, Card, Nav, Form, Button, Tabs, Tab, Modal, InputGroup, Accordion } from 'react-bootstrap';
import ExchangeIcon from '../../Pages/Presale/IconBox/ExchangeIcon';
import { LiaAngleDownSolid } from "react-icons/lia";
import { IoSearch } from "react-icons/io5";
import Web3ModalProvider from '../../Pages/Presale/Connectwallet/Web3ModalProvider';
import { useSelector } from 'react-redux';
import { INFI_CONTRACT, INFI_DECIMAL, LIQUIDITY_CONTRACT, USDT_CONTRACT, USDT_DECIMAL } from '../../Web3/web3Config';
import { BlockchainRemoveLiquidity, getCalculateAmountForLiquidity, getLiquidityPoolDetial, BloackchainGetTokenBalance, BloackchainCheckAllowanceAndApprove, BlockchainAddLiquidity } from '../../Web3/SwapConnector';
import { Removeliquidity } from './Removeliquidity';
import { Spin } from 'antd';
import { Success, Warning } from '../../../utils/errors';
import { Addliquiditypool } from './Addliquidity';


const tokenAObj = {
    balance: 0,
    symbol: "INFI",
    icon: "assets/images/coin/eth.svg",
    contract: INFI_CONTRACT,
    amount: '',
    decimal: INFI_DECIMAL
}
const tokenBObj = {
    balance: 0,
    symbol: "USDT",
    icon: "assets/images/coin/infi.svg",
    contract: USDT_CONTRACT,
    amount: '',
    decimal: USDT_CONTRACT
}



const Liquiditypool = () => {

    const _useWeb3ModalProvider = Web3ModalProvider()
    const walletConnnected = useSelector((state) => state.auth.walletConnnected);
    const loginDetails = useSelector((state) => state.auth.LoginDetails);
    const [connectWalletNow, setConnectWalletNow] = useState(false);
    const [WalletAddress, setWalletAddress] = useState("")
    const [isProviderLoaded, setisProviderLoaded] = useState(false);
    const navigate = useNavigate();
    const [IsProcessing, setIsProcessing] = useState(false);
    const [PageLoading, setPageLoading] = useState(false);

    const [removeLiquidityModal, setRemoveLiquidityModal] = useState(false);
    const [addLiquidityModal, setAddLiquidityModal] = useState(false);
    const [tokenA, setTokenA] = useState(tokenAObj)
    const [tokenB, setTokenB] = useState(tokenBObj)
    const [PoolDetials, setPoolDetials] = useState({});
    const [infiPriceInUsdt, setInfiPriceInUsdt] = useState(0);
    const [usdtPriceInInfi, setUsdtPriceInInfi] = useState(0);

    const [CoinBalance, setCoinBalance] = useState({
        INFI: 0,
        USDT: 0
    })


    useEffect(() => {
        setWalletAddress(walletConnnected);
    }, [walletConnnected])


    useEffect(() => {
        if (!isProviderLoaded) {
            _useWeb3ModalProvider.then(data => {
                if (data) {
                    setisProviderLoaded(true);
                }
            })
        }
    }, [_useWeb3ModalProvider])


    useEffect(() => {
        if (isProviderLoaded) {
            getPoolDetails();
        }
    }, [isProviderLoaded, walletConnnected]);

    const getPoolDetails = async () => {
        try {
            setPageLoading(true);
            let res = await getLiquidityPoolDetial({
                liquidityContract: LIQUIDITY_CONTRACT,
                walletProvider: _useWeb3ModalProvider,
                walletAddress: walletConnnected
            });

            let infiTokenInPool = await BloackchainGetTokenBalance(LIQUIDITY_CONTRACT, tokenA.contract, _useWeb3ModalProvider);
            let usdtTokenInPool = await BloackchainGetTokenBalance(LIQUIDITY_CONTRACT, tokenB.contract, _useWeb3ModalProvider);
            if (infiTokenInPool.status) {
                console.log({ infiTokenInPool, usdtTokenInPool })
                res.usdtTokenInPool = usdtTokenInPool.balance;
                res.infiTokenInPool = infiTokenInPool.balance
            }
            setPoolDetials(res);
            setInfiPriceInUsdt(res.InfiPriceInUsdt);
            setUsdtPriceInInfi(res.UsdtPriceInInfi);

            let infiTokenBalance = await BloackchainGetTokenBalance(walletConnnected, tokenA.contract, _useWeb3ModalProvider);
            let usdtTokenBalance = await BloackchainGetTokenBalance(walletConnnected, tokenB.contract, _useWeb3ModalProvider);
            if (infiTokenInPool.status) {

                setCoinBalance({
                    INFI: infiTokenBalance.balance,
                    USDT: usdtTokenBalance.balance
                })
            }

            setPageLoading(false);

        }
        catch (error) {
            setPageLoading(false);
            console.log(error);
        }
    }

    const calculateAmountForLiquidity = async (coin, amount) => {
        try {
            console.log({ coin, amount })
            let res = await getCalculateAmountForLiquidity({
                liquidityContract: LIQUIDITY_CONTRACT,
                walletProvider: _useWeb3ModalProvider,
                coin,
                amount
            });
            return { returnAmount: res.returnAmount, getLpToken: res.getLpToken };
        }
        catch (error) {
            console.log(error);
            return 0;
        }
    }


    const addLiquidityNow = async (LpToken) => {
        if (parseFloat(LpToken) == 0) {
            return;
        }

        setIsProcessing(true);
        const removeLpRes = await BlockchainRemoveLiquidity({
            walletAddress: walletConnnected,
            liquidityContract: LIQUIDITY_CONTRACT,
            LpToken: parseFloat(LpToken),
            walletProvider: _useWeb3ModalProvider
        });
        setIsProcessing(false);

        if (removeLpRes.status) {
            Success("Token purchased successfully, It will take a few minutes to confirm the transaction.");
            setRemoveLiquidityModal(false)
        } else {
            Warning(removeLpRes.message)
        }


    }


    const removeLiquidityNow = async (LpToken) => {

        setIsProcessing(true);
        const removeLpRes = await BlockchainRemoveLiquidity({
            walletAddress: walletConnnected,
            liquidityContract: LIQUIDITY_CONTRACT,
            LpToken: parseFloat(LpToken),
            walletProvider: _useWeb3ModalProvider
        });
        setIsProcessing(false);
        return removeLpRes;
    }

    const approveToken = async (coin, amount) => {
        const res = await BloackchainCheckAllowanceAndApprove({
            contractAddress: coin == tokenA.symbol ? tokenA.contract : tokenB.contract,
            walletAddress: walletConnnected,
            liquidityContract: LIQUIDITY_CONTRACT,
            amount: amount,
            walletProvider: _useWeb3ModalProvider
        });
        return res;
    }


    const addLiquidity = async (infiAmount, usdtAmount) => {
        const res = await BlockchainAddLiquidity({
            infiAmount: infiAmount,
            usdtAmount: usdtAmount,
            isPairCreated: PoolDetials.isPairCreated,
            walletAddress: walletConnnected,
            liquidityContract: LIQUIDITY_CONTRACT,
            walletProvider: _useWeb3ModalProvider
        });
        return res;
    }


    const goToLogin = async () => {
        navigate(config.baseurl + 'login')
    }

    const openAddLiquidityForm = () => {
        if (!loginDetails.isLogin) {
            goToLogin()
            return;
        }
        if (!walletConnnected) {
            setConnectWalletNow(true)
            return;
        }
        setAddLiquidityModal(true)
    }

    return (
        <>
            <Header connectWalletNow={connectWalletNow} setconnectWalletNow={setConnectWalletNow} />

            <div className='subheader'>
                <img src='assets/images/liquidity_banner.png' width={`100%`} />
            </div>
            <div className="dashboard pt-5 pb-5 position-relative">
                <section className="pb-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <Row className='align-items-center'>
                                    <Col lg={6} xs={6}>
                                        <h1 className='mb-0'>Your Liquidity</h1>
                                    </Col>
                                    <Col lg={6} xs={6} className='text-right'>
                                        <Button variant='primary' className='fw-bold text-black' onClick={() => openAddLiquidityForm()}>Add Liquidity</Button>
                                    </Col>
                                </Row>

                                <Row>
                                    {PageLoading &&
                                        <Col lg={12}>
                                            <Spin spinning={PageLoading}>
                                                <div className='mt-5' style={{ width: '100%', height: '300px' }}>
                                                </div>
                                            </Spin>
                                        </Col>}
                                </Row>

                                {!PageLoading &&
                                    <Row >
                                        <Col lg={12} className='py-4'>
                                            <Row >
                                                <Col lg={4}>
                                                    {/* <Form.Select aria-label="Default select example">
                                                    <option>Account analytics and accrued fees</option>
                                                    <option value="1">One</option>
                                                    <option value="2">Two</option>
                                                    <option value="3">Three</option>
                                                </Form.Select> */}
                                                </Col>
                                                <Col lg={8}>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col lg={12}>
                                            {!loginDetails.isLogin && <Button variant='primary' className='w-100 fs-5 text-black' onClick={goToLogin}>Login</Button>}

                                            {!walletConnnected &&
                                                <Button variant='primary' className='w-100 fs-5 text-black' onClick={() => setConnectWalletNow(true)}>Connect Wallet</Button>
                                            }
                                        </Col>


                                        {PoolDetials.userLpToken > 0 && loginDetails.isLogin && walletConnnected &&
                                            <Col lg={12}>
                                                <div className='Accordion-table'>
                                                    <Accordion defaultActiveKey={['0']} alwaysOpen>
                                                        <Accordion.Item eventKey="0" className='mb-3'>
                                                            <Accordion.Header className='table-h'>
                                                                <Row className='align-items-center w-100'>
                                                                    <Col lg={8} xs={9}>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className='me-2'>
                                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 54 54" fill="none" className='bus'>
                                                                            <circle cx="26.963" cy="26.963" r="26.963" fill="#D9D9D9" />
                                                                            <path d="M11.7109 34.185V23.342H15.8132C16.2369 23.342 16.6927 23.3741 17.1806 23.4383C17.6685 23.4897 18.1243 23.6116 18.548 23.8042C18.9717 23.984 19.3183 24.2665 19.588 24.6516C19.8576 25.0368 19.9924 25.5568 19.9924 26.2116C19.9924 26.6225 19.909 27.0077 19.742 27.3672C19.588 27.7139 19.2991 27.9963 18.8754 28.2146C18.4517 28.4329 17.8482 28.5548 17.065 28.5805V28.6576C17.9766 28.6704 18.6764 28.7988 19.1643 29.0427C19.665 29.2867 20.0117 29.6077 20.2043 30.0057C20.3969 30.3909 20.4932 30.821 20.4932 31.2961C20.4932 31.9766 20.3455 32.5094 20.0502 32.8946C19.7549 33.2798 19.3761 33.5687 18.9139 33.7613C18.4517 33.941 17.9574 34.0566 17.4309 34.1079C16.9174 34.1593 16.4295 34.185 15.9672 34.185H11.7109ZM13.2902 27.9642H15.6206C16.147 27.9642 16.6156 27.9385 17.0265 27.8872C17.4502 27.823 17.784 27.6753 18.028 27.4442C18.2719 27.2131 18.3939 26.8536 18.3939 26.3657C18.3939 25.8393 18.2655 25.4605 18.0087 25.2294C17.7519 24.9855 17.4117 24.8314 16.988 24.7672C16.5643 24.703 16.1149 24.6709 15.6398 24.6709H13.2902V27.9642ZM13.2902 32.8753H15.8324C16.3845 32.8753 16.8853 32.8432 17.3346 32.779C17.784 32.702 18.1435 32.5415 18.4132 32.2976C18.6956 32.0408 18.8369 31.6427 18.8369 31.1035C18.8369 30.5514 18.6892 30.1405 18.3939 29.8709C18.1114 29.6013 17.7262 29.4279 17.2383 29.3509C16.7633 29.261 16.2433 29.2161 15.6783 29.2161H13.2902V32.8753Z" fill="white" />
                                                                            <path d="M26.7876 34.4546C25.2982 34.4546 24.1555 34.0309 23.3595 33.1835C22.5763 32.3232 22.1847 31.1163 22.1847 29.5627V23.342H23.8602V29.5435C23.8602 30.3781 23.995 31.0457 24.2647 31.5465C24.5343 32.0344 24.8874 32.3874 25.3239 32.6057C25.7733 32.824 26.2612 32.9331 26.7876 32.9331C27.3654 32.9331 27.8726 32.8304 28.3091 32.625C28.7585 32.4067 29.1052 32.0536 29.3491 31.5657C29.6059 31.065 29.7343 30.3909 29.7343 29.5435V23.342H31.4098V29.5627C31.4098 31.142 31.0182 32.3553 30.235 33.2027C29.4647 34.0373 28.3155 34.4546 26.7876 34.4546Z" fill="white" />
                                                                            <path d="M37.7064 34.4161C36.9232 34.4161 36.1721 34.2941 35.4531 34.0502C34.7341 33.7934 34.1435 33.3953 33.6812 32.8561C33.2319 32.304 33.0007 31.5914 32.9879 30.7183H34.6057C34.6057 30.7697 34.6249 30.9173 34.6635 31.1613C34.7148 31.3924 34.8368 31.6492 35.0294 31.9316C35.2348 32.2013 35.5558 32.4388 35.9923 32.6442C36.4289 32.8497 37.0388 32.9524 37.822 32.9524C38.4511 32.9524 38.9454 32.8625 39.3049 32.6827C39.6773 32.503 39.9341 32.2911 40.0753 32.0472C40.2294 31.8032 40.3128 31.585 40.3257 31.3924C40.3257 30.9944 40.1973 30.6734 39.9405 30.4294C39.6965 30.1855 39.3627 29.9929 38.939 29.8516C38.5153 29.6976 38.0467 29.5627 37.5331 29.4472C37.0323 29.3188 36.5316 29.184 36.0309 29.0427C35.5301 28.8887 35.0679 28.6897 34.6442 28.4457C34.2333 28.2018 33.9059 27.8872 33.662 27.502C33.4309 27.104 33.3346 26.5968 33.3731 25.9805C33.4116 25.0946 33.8289 24.4013 34.6249 23.9005C35.4338 23.3998 36.4738 23.1494 37.7449 23.1494C38.4896 23.1494 39.183 23.2842 39.8249 23.5539C40.4669 23.8235 40.9805 24.2279 41.3657 24.7672C41.7509 25.3065 41.9435 25.9805 41.9435 26.7894H40.3835C40.3835 26.34 40.2872 25.9805 40.0946 25.7109C39.902 25.4284 39.658 25.2102 39.3627 25.0561C39.0674 24.902 38.7593 24.7993 38.4383 24.7479C38.1173 24.6837 37.8284 24.6516 37.5716 24.6516C36.8398 24.6516 36.2363 24.7865 35.7612 25.0561C35.299 25.3257 35.0679 25.6916 35.0679 26.1539C35.0551 26.5647 35.177 26.8921 35.4338 27.1361C35.6906 27.38 36.0309 27.5726 36.4546 27.7139C36.8783 27.8551 37.3405 27.9835 37.8412 28.099C38.3548 28.2146 38.862 28.343 39.3627 28.4842C39.8763 28.6255 40.3385 28.8181 40.7494 29.062C41.1731 29.2931 41.5005 29.6141 41.7316 30.025C41.9756 30.423 42.0847 30.9302 42.059 31.5465C42.0205 32.1499 41.8086 32.6699 41.4235 33.1065C41.0511 33.5302 40.544 33.8576 39.902 34.0887C39.26 34.3069 38.5282 34.4161 37.7064 34.4161Z" fill="white" />
                                                                        </svg> */}
                                                                            </div>
                                                                            <div className='me-2'>
                                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 54 54" fill="none">
                                                                            <path d="M27.0372 53.9259C41.9284 53.9259 54.0001 41.8542 54.0001 26.963C54.0001 12.0717 41.9284 0 27.0372 0C12.1459 0 0.0742188 12.0717 0.0742188 26.963C0.0742188 41.8542 12.1459 53.9259 27.0372 53.9259Z" fill="#627EEA" />
                                                                            <path d="M27.875 6.74121V21.6888L40.5088 27.3342L27.875 6.74121Z" fill="#DDDDDD" />
                                                                            <path d="M27.8758 6.74121L15.2402 27.3342L27.8758 21.6888V6.74121Z" fill="white" />
                                                                            <path d="M27.875 37.0205V47.1771L40.5173 29.6865L27.875 37.0205Z" fill="#DDDDDD" />
                                                                            <path d="M27.8758 47.1771V37.0188L15.2402 29.6865L27.8758 47.1771Z" fill="white" />
                                                                            <path d="M27.875 34.67L40.5088 27.3344L27.875 21.6924V34.67Z" fill="#DDDDDD" />
                                                                            <path d="M15.2402 27.3344L27.8758 34.67V21.6924L15.2402 27.3344Z" fill="#DDDDDD" />
                                                                        </svg> */}
                                                                            </div>
                                                                            <span className='fs-4'>INFI/USDT</span>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={4} xs={3} className='text-right'>
                                                                        {/* <div className=''>
                                                                    <span className='text-blue'><a>Message</a></span>
                                                                </div> */}
                                                                    </Col>
                                                                </Row>

                                                            </Accordion.Header>
                                                            <Accordion.Body>
                                                                <div>
                                                                    <Row>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2'>
                                                                            <h5 className='small'>Your Total LP Token</h5>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2 text-right'>
                                                                            <p className='small'>{PoolDetials.userLpToken}</p>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2'>
                                                                            <h5 className='small'>Pooled INFI</h5>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2 text-right'>
                                                                            <p className='small'>{PoolDetials.infiTokenInPool}&nbsp;
                                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" className='bus'>
                                                                            <circle cx="10.037" cy="10.037" r="10.037" fill="#D9D9D9" />
                                                                            <path d="M4.35938 12.7252V8.68888H5.88644C6.04416 8.68888 6.21384 8.70083 6.39546 8.72473C6.57708 8.74385 6.74676 8.78925 6.90448 8.86094C7.06221 8.92786 7.19125 9.03301 7.29162 9.17639C7.39199 9.31978 7.44218 9.51335 7.44218 9.75711C7.44218 9.91005 7.41111 10.0534 7.34898 10.1873C7.29162 10.3163 7.18408 10.4215 7.02636 10.5027C6.86863 10.584 6.644 10.6294 6.35244 10.6389V10.6676C6.69179 10.6724 6.95228 10.7202 7.1339 10.811C7.3203 10.9018 7.44935 11.0213 7.52104 11.1695C7.59273 11.3128 7.62858 11.473 7.62858 11.6498C7.62858 11.9031 7.57362 12.1015 7.46369 12.2449C7.35376 12.3882 7.21276 12.4958 7.0407 12.5675C6.86863 12.6344 6.68462 12.6774 6.48866 12.6965C6.29748 12.7156 6.11586 12.7252 5.94379 12.7252H4.35938ZM4.94726 10.4095H5.81475C6.01071 10.4095 6.18516 10.4 6.33811 10.3808C6.49583 10.3569 6.6201 10.302 6.71091 10.2159C6.80172 10.1299 6.84713 9.99609 6.84713 9.81446C6.84713 9.6185 6.79933 9.4775 6.70374 9.39147C6.60815 9.30066 6.48149 9.24331 6.32377 9.21941C6.16604 9.19551 5.99876 9.18356 5.82191 9.18356H4.94726V10.4095ZM4.94726 12.2377H5.89361C6.09913 12.2377 6.28553 12.2257 6.45281 12.2018C6.6201 12.1732 6.75393 12.1134 6.8543 12.0226C6.95945 11.927 7.01202 11.7789 7.01202 11.5781C7.01202 11.3726 6.95706 11.2196 6.84713 11.1193C6.74198 11.0189 6.59859 10.9544 6.41697 10.9257C6.24012 10.8922 6.04655 10.8755 5.83625 10.8755H4.94726V12.2377Z" fill="white" />
                                                                            <path d="M9.97171 12.8256C9.41729 12.8256 8.99191 12.6678 8.69558 12.3524C8.40402 12.0322 8.25825 11.5829 8.25825 11.0046V8.68888H8.88198V10.9974C8.88198 11.3081 8.93216 11.5566 9.03253 11.743C9.1329 11.9246 9.26434 12.0561 9.42685 12.1373C9.59413 12.2186 9.77575 12.2592 9.97171 12.2592C10.1868 12.2592 10.3756 12.221 10.5381 12.1445C10.7054 12.0632 10.8344 11.9318 10.9252 11.7502C11.0208 11.5638 11.0686 11.3128 11.0686 10.9974V8.68888H11.6923V11.0046C11.6923 11.5925 11.5466 12.0441 11.255 12.3596C10.9682 12.6702 10.5405 12.8256 9.97171 12.8256Z" fill="white" />
                                                                            <path d="M14.0363 12.8112C13.7447 12.8112 13.4651 12.7658 13.1975 12.675C12.9298 12.5794 12.7099 12.4313 12.5379 12.2305C12.3706 12.025 12.2846 11.7597 12.2798 11.4347H12.882C12.882 11.4538 12.8892 11.5088 12.9035 11.5996C12.9226 11.6857 12.968 11.7812 13.0397 11.8864C13.1162 11.9868 13.2357 12.0752 13.3982 12.1517C13.5607 12.2281 13.7877 12.2664 14.0793 12.2664C14.3135 12.2664 14.4975 12.2329 14.6313 12.166C14.7699 12.0991 14.8655 12.0202 14.9181 11.9294C14.9754 11.8386 15.0065 11.7573 15.0113 11.6857C15.0113 11.5375 14.9635 11.418 14.8679 11.3272C14.7771 11.2364 14.6528 11.1647 14.4951 11.1121C14.3374 11.0548 14.1629 11.0046 13.9717 10.9616C13.7853 10.9138 13.5989 10.8636 13.4125 10.811C13.2261 10.7536 13.0541 10.6796 12.8963 10.5887C12.7434 10.4979 12.6215 10.3808 12.5307 10.2375C12.4447 10.0893 12.4088 9.90049 12.4232 9.67108C12.4375 9.34129 12.5928 9.08319 12.8892 8.89679C13.1903 8.71039 13.5774 8.61719 14.0506 8.61719C14.3278 8.61719 14.5859 8.66737 14.8249 8.76774C15.0639 8.86811 15.255 9.01867 15.3984 9.21941C15.5418 9.42015 15.6135 9.67108 15.6135 9.97219H15.0328C15.0328 9.8049 14.997 9.67108 14.9253 9.57071C14.8536 9.46556 14.7628 9.3843 14.6528 9.32695C14.5429 9.26959 14.4282 9.23136 14.3087 9.21224C14.1892 9.18834 14.0817 9.17639 13.9861 9.17639C13.7136 9.17639 13.489 9.22658 13.3122 9.32695C13.1401 9.42732 13.0541 9.56354 13.0541 9.7356C13.0493 9.88855 13.0947 10.0104 13.1903 10.1012C13.2859 10.192 13.4125 10.2637 13.5703 10.3163C13.728 10.3689 13.9 10.4167 14.0865 10.4597C14.2776 10.5027 14.4664 10.5505 14.6528 10.6031C14.844 10.6557 15.0161 10.7274 15.169 10.8182C15.3267 10.9042 15.4486 11.0237 15.5347 11.1766C15.6255 11.3248 15.6661 11.5136 15.6565 11.743C15.6422 11.9676 15.5633 12.1612 15.4199 12.3237C15.2813 12.4814 15.0925 12.6033 14.8536 12.6894C14.6146 12.7706 14.3422 12.8112 14.0363 12.8112Z" fill="white" />
                                                                        </svg> */}
                                                                            </p>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2'>
                                                                            <h5 className='small'>Pooled USDT</h5>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2 text-right'>
                                                                            <p className='small'>{PoolDetials.usdtTokenInPool}&nbsp;
                                                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                                                            <path d="M10.037 20.0741C15.5803 20.0741 20.0741 15.5803 20.0741 10.037C20.0741 4.49373 15.5803 0 10.037 0C4.49373 0 0 4.49373 0 10.037C0 15.5803 4.49373 20.0741 10.037 20.0741Z" fill="#627EEA" />
                                                                            <path d="M10.3496 2.50977V8.07405L15.0526 10.1756L10.3496 2.50977Z" fill="#DDDDDD" />
                                                                            <path d="M10.3501 2.50977L5.64648 10.1756L10.3501 8.07405V2.50977Z" fill="white" />
                                                                            <path d="M10.3496 13.7809V17.5617L15.0557 11.0508L10.3496 13.7809Z" fill="#DDDDDD" />
                                                                            <path d="M10.3501 17.5617V13.7802L5.64648 11.0508L10.3501 17.5617Z" fill="white" />
                                                                            <path d="M10.3496 12.9061L15.0526 10.1754L10.3496 8.0752V12.9061Z" fill="#DDDDDD" />
                                                                            <path d="M5.64648 10.1754L10.3501 12.9061V8.0752L5.64648 10.1754Z" fill="#DDDDDD" />
                                                                        </svg> */}
                                                                            </p>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2'>
                                                                            <h5 className='small'>Your pool share</h5>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className='mb-2 text-right'>
                                                                            <p className='small'>{(PoolDetials.userLpToken / PoolDetials.totalLpToken * 100).toFixed(4)}%</p>
                                                                        </Col>
                                                                        {/* <Col lg={12} className='mb-3 text-center'>
                                                                    <h5 className='small text-blue'>View Accrued fees and analytics</h5>
                                                                </Col> */}
                                                                        <Col lg={6} md={6} xs={6} className=''>
                                                                            <Button className='w-100 fw-bold text-black' onClick={() => setAddLiquidityModal(true)}>Add</Button>
                                                                        </Col>
                                                                        <Col lg={6} md={6} xs={6} className=''>
                                                                            <Button className='w-100 fw-bold text-black' onClick={() => setRemoveLiquidityModal(true)}>Remove</Button>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Accordion>

                                                </div>
                                            </Col>
                                        }

                                        {PoolDetials.userLpToken == 0 &&
                                            <Col lg={12}>
                                                <div className='text-center'>
                                                    <img src='assets/images/icon/docsearch.svg' width={`110`} />
                                                    <h4 className='mt-3'>No Liquidity found</h4>
                                                </div>
                                            </Col>}
                                        {/* ------Add liquidity Modal------- */}
                                        <Modal show={addLiquidityModal} backdrop={'static'} keyboard={false} onHide={() => setAddLiquidityModal(false)} centered>
                                            <Spin spinning={IsProcessing}>
                                                <Modal.Header closeButton>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Addliquiditypool
                                                        infiBalance={CoinBalance.INFI || 0}
                                                        usdtBalance={CoinBalance.USDT || 0}
                                                        isPairCreated={PoolDetials.isPairCreated || false}
                                                        totalLpToken={PoolDetials.totalLpToken || 0}
                                                        userLpToken={PoolDetials.userLpToken || 0}
                                                        closeModal={() => {
                                                            setAddLiquidityModal(false)
                                                            getPoolDetails()
                                                        }}
                                                        addLiquidityNow={(LpToken) => addLiquidityNow(LpToken)}
                                                        calculateAmountForLiquidity={calculateAmountForLiquidity}
                                                        approveToken={approveToken}
                                                        addLiquidity={addLiquidity}
                                                    />
                                                </Modal.Body>
                                            </Spin>
                                        </Modal>
                                        {/* -------Add liquidity Modal------ */}


                                        {/* ------Remove liquidity Modal------- */}
                                        <Modal show={removeLiquidityModal} backdrop={'static'} keyboard={false} onHide={() => setRemoveLiquidityModal(false)} centered>
                                            <Spin spinning={IsProcessing}>
                                                <Modal.Header closeButton>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Removeliquidity
                                                        infiPriceInUsdt={infiPriceInUsdt || 0}
                                                        usdtPriceInInfi={usdtPriceInInfi || 0}
                                                        userLpToken={PoolDetials.userLpToken || 0}
                                                        closeModal={() => {
                                                            setRemoveLiquidityModal(false)
                                                            getPoolDetails()
                                                        }}
                                                        removeLiquidity={(LpToken) => removeLiquidityNow(LpToken)}
                                                    />
                                                </Modal.Body>
                                            </Spin>
                                        </Modal>
                                        {/* -------Remove liquidity Modal------ */}
                                    </Row>}
                            </Col>

                        </Row>
                    </Container>

                </section>
            </div>
            <Footer bg="bg-primary" />

        </>
    )
}

export default Liquiditypool;
